// DEFCAT-FU-05 — component-group list for the New-Defect drawer's L0 override.
//
// The catalogue location entries carry `componentGroupId` (UUID), but the group
// *labels* live in companies_db and the UUIDs are environment-specific, so the
// drawer must resolve id → label from the API. Component groups are an `assets`
// resource (`GET /api/assets/v1/component-groups`), while this app's `useApi()`
// is base-pinned to `/api/lyse/v1` — so we pass a per-request `baseURL` override
// (`getAssetsBaseUrl()`), the same cross-namespace pattern the catalogue admin
// editor uses for `taxonomy/v1`.
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "@aeriosiq/api-client";
import { getAssetsBaseUrl } from "@aeriosiq/auth-client";

export interface ComponentGroupItem {
  id: string;
  groupCode: string;
  name: Record<string, string>;
}
export interface ListComponentGroupsResponse {
  items: ComponentGroupItem[];
  total: number;
}

export const componentGroupsKeys = {
  all: ["component-groups"] as const,
};

/** The 7 (soon 8) `global_component_groups`. Near-static catalogue data. */
export function useComponentGroups(): UseQueryResult<ListComponentGroupsResponse> {
  const api = useApi();
  return useQuery<ListComponentGroupsResponse>({
    queryKey: componentGroupsKeys.all,
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await api.get<ListComponentGroupsResponse>(
        "/component-groups",
        { baseURL: getAssetsBaseUrl() },
      );
      return res.data;
    },
  });
}
